import { Box } from "@chakra-ui/react";
import {
  colors,
  getCdnImageSrc,
  HStack,
  Image,
  NextLink,
  VStack,
} from "goi_common";
import CareRegionHeadSection from "./components/region/CareRegionHeadSection";
import CareRegionTabSection from "./components/region/CareRegionTabSection";

export default function CareRegionContainer({
  regionCares,
  hasSigungu,
  sidoName,
  sido,
  sigunguName,
  sigungu,
}: {
  regionCares: Array<any>;
  hasSigungu?: boolean;
  sidoName: string;
  sido: string;
  sigunguName?: string;
  sigungu?: string;
}) {
  const typeCountArray = regionCares.reduce((acc, item) => {
    let type = item.type || "알 수 없는 유형";

    if (type === "알 수 없는 유형" || type.includes("치매전담")) return acc;

    if (type.startsWith("재가노인복지시설")) {
      type = "재가노인복지시설";
    } else if (type.startsWith("재가장기요양기관")) {
      type = "재가장기요양기관";
    }

    const existingType = acc.find(
      (entry: { type: string }) => entry.type === type
    );

    if (existingType) {
      existingType.count += 1;
    } else {
      acc.push({ type, count: 1 });
    }

    return acc;
  }, []);

  return (
    <VStack width="100%" alignItems="center">
      <VStack width="100%" maxWidth="480px" padding="32px 0">
        <CareRegionHeadSection
          sido={sido}
          sidoName={sidoName}
          sigunguName={sigunguName}
          regionCareCount={regionCares.length}
        />
        <VStack
          padding="10px 20px"
          margin="16px 20px 0"
          gap="10px"
          background={colors.warmGray200}
          borderRadius="10px"
        >
          {typeCountArray.map(
            (
              { type, count }: { type: string; count: number },
              index: number
            ) => (
              <HStack
                as="div"
                className="subtitle_14_sb"
                key={type + index}
                justifyContent="space-between"
                alignItems="center"
                gap="8px"
              >
                <p css={{ flexShrink: 0, color: colors.brown750 }}>{type}</p>
                <Box height="1.2px" width="100%" overflow="hidden">
                  <Box
                    width="100%"
                    borderTopWidth="3px"
                    borderStyle="dashed"
                    borderColor={colors.warmGray700}
                  />
                </Box>
                <div css={{ flexShrink: 0, color: colors.brown750 }}>
                  {count}개
                </div>
              </HStack>
            )
          )}
        </VStack>

        <VStack padding="20px 0 0">
          <NextLink
            href="https://prime.goifuneral.co.kr/?utm_campaign=nursing_hospital_region"
            event={{
              newGtm: {
                path: "care_detail",
                trigger_and_target: "uv_prime",
              },
            }}
          >
            <Image
              src={getCdnImageSrc("direct/100_banner_2.png")}
              alt=""
              width="100%"
            />
          </NextLink>
        </VStack>

        <CareRegionTabSection
          regionCares={regionCares}
          sidoName={sidoName}
          sigunguName={sigunguName}
        />
      </VStack>
    </VStack>
  );
}
